import { Component, OnInit, ViewChild } from '@angular/core';
import { CsDatepickerPlain }            from '@cs/components/datepicker';
import { ControlWidget }                from '../models/control-widget.directive';
import { NgbDateStruct }                from '@cs/components/datepicker/datepicker-core/ngb-date-struct';
import { ValidationAnnotationType }     from '@cs/core';

@Component({
	standalone: false,
	selector: 'date-picker-widget',
	template: `
				<cs-datepicker-plain [formControl]="control"
									 [attr.id]="id"
									 #dp="picker"
									 [disabled]="readOnly"
									 [minDate]="minDate"
									 [maxDate]="maxDate"
				></cs-datepicker-plain>
				<div class="pm-form-element-invalid-feedback" *ngIf="errorMessages?.length> 0 ">
					<small class="{{error.type}}" *ngFor="let error of errorMessages">{{error.errorMessage}}</small>
				</div>`
})

export class DatePickerWidgetComponent<T> extends ControlWidget<T> implements OnInit {

	@ViewChild('dp') datepicker: CsDatepickerPlain;
	
	minDate: NgbDateStruct | null = null;
	maxDate: NgbDateStruct | null = null;

	ngOnInit() {
		super.ngOnInit();
		this.applyDateConstraints();
	}

	/**
	 * Apply minDate/maxDate constraints from validators (DateRangeValidationAnnotation)
	 */
	private applyDateConstraints() {
		if (!this.propertyAnnotation?.validators) return;

		const rangeValidator = this.propertyAnnotation.validators.find(
			v => v.type === ValidationAnnotationType.Range
		) as any;

		if (rangeValidator) {
			if (rangeValidator.minimum != null) {
				this.minDate = this.toDateStruct(rangeValidator.minimum);
			}
			if (rangeValidator.maximum != null) {
				this.maxDate = this.toDateStruct(rangeValidator.maximum);
			}
		}
	}

	/**
	 * Convert various date formats to NgbDateStruct
	 * Supports: DateStruct/NgbDateStruct, Date object, timestamp (number), ISO string
	 */
	private toDateStruct(value: any): NgbDateStruct | null {
		if (value == null) return null;

		// Already NgbDateStruct format { year, month, day }
		if (typeof value === 'object' && value.year && value.month && value.day) {
			return { year: value.year, month: value.month, day: value.day };
		}

		// Date object
		if (value instanceof Date) {
			return {
				year: value.getFullYear(),
				month: value.getMonth() + 1,
				day: value.getDate()
			};
		}

		// Timestamp (number) or date string
		const dateObj = new Date(value);
		if (!isNaN(dateObj.getTime())) {
			return {
				year: dateObj.getFullYear(),
				month: dateObj.getMonth() + 1,
				day: dateObj.getDate()
			};
		}

		return null;
	}

	clearData() {
		super.clearData();
		this.datepicker.resetValueToEmpty();
	}
}
